import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Menu } from 'lucide-react';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet';
import Sidebar from './Sidebar';
import { NAV_LINKS } from '../config/nav';
import '../styles/MobileNav.css';

/**
 * Phone navigation. The sidebar is not rendered in the page at this width, so
 * the sheet carries it — otherwise the Discord channel list and changelogs are
 * unreachable on a phone entirely.
 */
const MobileNav = () => {
  const [open, setOpen] = useState(false);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger className="mobile-nav-trigger" aria-label="Open navigation">
        <Menu aria-hidden="true" />
      </SheetTrigger>
      {/* Opens from the left, where the sidebar lives on desktop. */}
      <SheetContent side="left" className="mobile-nav-panel">
        <SheetHeader>
          <SheetTitle>ISN Network</SheetTitle>
          <SheetDescription>Navigation, Discord and changelogs</SheetDescription>
        </SheetHeader>

        <nav className="mobile-nav-links">
          <ul>
            {NAV_LINKS.map((link) => (
              <li key={link.to}>
                <NavLink to={link.to} onClick={() => setOpen(false)}>
                  {link.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <Sidebar inSheet />
      </SheetContent>
    </Sheet>
  );
};

export default MobileNav;
